import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @polymerMixin
 */
export var ThemePropertyMixin = function ThemePropertyMixin(superClass) {
  return (
    /*#__PURE__*/
    function (_superClass) {
      _inherits(VaadinThemePropertyMixin, _superClass);

      function VaadinThemePropertyMixin() {
        _classCallCheck(this, VaadinThemePropertyMixin);

        return _possibleConstructorReturn(this, _getPrototypeOf(VaadinThemePropertyMixin).apply(this, arguments));
      }

      _createClass(VaadinThemePropertyMixin, [{
        key: "attributeChangedCallback",

        /** @protected */
        value: function attributeChangedCallback(name, oldValue, newValue) {
          _get(_getPrototypeOf(VaadinThemePropertyMixin.prototype), "attributeChangedCallback", this).call(this, name, oldValue, newValue);

          if (name === 'theme') {
            this._setTheme(newValue);
          }
        }
      }], [{
        key: "properties",
        get: function get() {
          return {
            /**
             * Helper property with theme attribute value facilitating propagation
             * in shadow DOM. Allows using `theme$="[[theme]]"` in the template.
             *
             * @protected
             */
            theme: {
              type: String,
              readOnly: true
            }
          };
        }
      }]);

      return VaadinThemePropertyMixin;
    }(superClass)
  );
};